import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  BIDS_DETAILS_URL,
  PRODUCT_IMAGE_URL,
  USER_IMAGE_URL,
} from "../../utils/Constant";
import styles from "./DetailView.module.css";
import PayPalFeeCollection from "./PayPalFeeCollection";

import DashboardLayout from "../../layouts/DashboardLayout";
import {
  formatDate,
  amountToWords,
  convertIsoToCustomFormat,
} from "../../utils/Helper";

const BidDetails = () => {
  const [bidDetails, setBidDetails] = useState([]);
  const navigate = useNavigate();
  const authToken = useSelector((state) => state.token);
  const { bidId } = useParams();

  const showToast = (loading, message, type, errors) => {
    let errorMessage = "";

    if (errors && errors.length > 0) {
      errorMessage = (
        <ul>
          {errors.map((error, index) => (
            <li key={index}>{error.msg}</li>
          ))}
        </ul>
      );
    }
    toast[type](
      <div>
        {loading} {message} {errorMessage}
      </div>,
      {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000, // milliseconds
      }
    );
  };
  const handlePrint = () => {
    window.print();
  };

  useEffect(() => {
    if (authToken) {
      const fetchDetails = async () => {
        try {
          if (bidId) {
            showToast(true, "Data Loading. Please wait..", "info");
          }
          const response = await fetch(`${BIDS_DETAILS_URL}/${bidId}`, {
            headers: {
              Authorization: `Bearer ${authToken.token}`,
            },
          });

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const data = await response.json();
          setBidDetails(data);
        } catch (error) {
          console.error("Error fetching product:", error);
        }
      };
      fetchDetails();
    } else {
      navigate("/login");
    }
  }, [bidId]);

  //console.log(bidDetails);

  // Assume BidDetails is an object with properties including bidStatus
  const bidStatus = bidDetails?.bidStatus || ""; // Ensure a default value if bidStatus is undefined

  // Map bid status to badge color
  const badgeColors = {
    pending_payment: "badge-warning",
    processing: "badge-info",
    on_hold: "badge-secondary",
    completed: "badge-success",
    cancelled: "badge-danger",
    refunded: "badge-dark",
    failed: "badge-danger",
    shipped: "badge-primary",
    delivered: "badge-success",
  };
  // Set default badge color if not found in the map
  const badgeColor = badgeColors[bidStatus] || "badge-primary";

  // Map PayPal response status to badge color
  const paypalBadgeColors = {
    COMPLETED: "badge-success",
    CREATED: "badge-info",
    DENIED: "badge-danger",
    EXPIRED: "badge-warning",
    FAILED: "badge-danger",
    "IN-PROGRESS": "badge-info",
    PARTIALLY_REFUNDED: "badge-dark",
    PENDING: "badge-warning",
    REFUNDED: "badge-dark",
    REVERSED: "badge-danger",
    VOIDED: "badge-secondary",
  };
  const date = new Date(bidDetails?.bidTime);
  const totatBillAmount = bidDetails?.totalAmount;
  const paymentStatus = (bidDetails?.paymentStatus || "").toUpperCase(); // Replace with your actual PayPal status
  const paypalBadgeColor = paypalBadgeColors[paymentStatus] || "badge-primary";

  // const formattedDate = new Intl.DateTimeFormat("en-US", {
  //     year: "numeric",
  //     month: "numeric",
  //     day: "numeric",
  //     hour: "numeric",
  //     minute: "numeric",
  // }).format(date);
  return (
    <DashboardLayout>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1>Bid Details</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item active">Bid Details</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="invoice p-3 mb-3">
                  <PayPalFeeCollection bidId={bidId} token={authToken?.token} />
                  <div className="row">
                    <div className="col-12">
                      <h4>
                        <i className="fas fa-globe" /> Mototrad.
                        <span className="float-right">
                          Invoice Date:{" "}
                          {convertIsoToCustomFormat(bidDetails?.bidTime)}
                        </span>
                        <br />
                        <span className="float-right">
                          Invoice No. : MTD-{bidDetails?.bidInvoiceId}
                        </span>
                      </h4>
                    </div>
                  </div>
                  <div
                    className="row invoice-info"
                    style={{ marginTop: "20px" }}
                  >
                    <div className="col-sm-3 invoice-col">
                      <h5>Payment Details : </h5>
                      <br />
                      <br />
                      <b>Transaction ID:</b> {bidDetails?.transactionId}
                      <br />
                      <br />
                      <b>Payment Date:</b>{" "}
                      {convertIsoToCustomFormat(bidDetails?.bidTime)}
                      <br />
                      <br />
                      <b>Payment Method:</b>{" "}
                      {bidDetails?.paymentMethod == "paypal"
                        ? "Paypal"
                        : bidDetails?.paymentMethod}
                      <br />
                      <br />
                      <b>
                        Payment Status:{" "}
                        <span className={`badge ${paypalBadgeColor}`}>
                          {paymentStatus.toLowerCase().charAt(0).toUpperCase() +
                            paymentStatus
                              .toLowerCase()
                              .slice(1)
                              .replace("_", " ")}
                        </span>
                      </b>
                    </div>
                    <div className="col-sm-3 invoice-col">
                      <h5>Bid Details :</h5>
                      <br />
                      <br />
                      <b>Bid No. : #{bidDetails?.bidId}</b>
                      <br />
                      <br />
                      <b>Bid Date:</b>{" "}
                      {convertIsoToCustomFormat(bidDetails?.bidTime)}
                      <br />
                      <br />
                      <b>
                        Bid Status:{" "}
                        <span className={`badge ${badgeColor}`}>
                          {bidStatus.charAt(0).toUpperCase() +
                            bidStatus.slice(1).replace("_", " ")}
                        </span>
                      </b>
                      <br />
                      <br />
                    </div>
                    <div className="col-sm-3 invoice-col">
                      <h5>
                        Sold By :<br />
                      </h5>
                      <br />
                      <address>
                        <strong>Mototrad</strong>
                        <br />
                        795 Folsom Ave, Suite 600
                        <br />
                        San Francisco, CA 94107
                        <br />
                        <br />
                        <b>Phone:</b> (804) 123-5432
                        <br />
                        <b>Email:</b> info@mototrad.com
                      </address>
                    </div>
                    <div className="col-sm-3 invoice-col">
                      <h5>
                        {" "}
                        Customer Details :<br />
                      </h5>
                      <br />
                      <address>
                        <strong>
                          {bidDetails?.customerId?.firstName}{" "}
                          {bidDetails?.customerId?.lastName}
                        </strong>
                        <br />
                        {bidDetails?.customerId?.address}
                        <br />
                        <br />
                        <b>Phone: </b>
                        {bidDetails?.customerId?.phone}
                        <br />
                        <b>Email:</b>
                        {bidDetails?.customerId?.email}
                      </address>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 table-responsive">
                      <table className="table table-striped" bbid={1}>
                        <thead>
                          <tr>
                            <th>Image</th>
                            <th>Product</th>
                            <th>Qty</th>
                            <th>Subtotal</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <a
                                href={`https://www.mototrad.com/products/${bidDetails?.productId?._id}`}
                                target="_blank"
                              >
                                <img
                                  style={{ height: "60px" }}
                                  alt=""
                                  className="table-avatar"
                                  src={`${PRODUCT_IMAGE_URL}/${bidDetails?.productId?.featuredImage}`}
                                />
                              </a>
                            </td>

                            <td>
                              <h6>
                                <a
                                  href={`https://www.mototrad.com/products/${bidDetails?.productId?._id}`}
                                  target="_blank"
                                >
                                  {bidDetails?.productId?.productName}
                                </a>
                              </h6>
                            </td>
                            <td>
                              <h6>1</h6>
                            </td>
                            <td>
                              <h6>${bidDetails?.bidAmount}</h6>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <div className="table-responsive">
                        <table className="table">
                          <tbody>
                            <tr>
                              <th style={{ width: "50%" }}>Subtotal:</th>
                              <td>${bidDetails?.bidAmount}</td>
                            </tr>
                            <tr>
                              <th>
                              Mototrad Commission
                                {/* (
                                {bidDetails?.productId?.premiumType === "flat"
                                  ? "Flat" +
                                    bidDetails?.productId?.premiumAmount
                                  : bidDetails?.productId?.premiumAmount +
                                    "%"}
                                ) */}
                              </th>
                              <td>${bidDetails?.premiumAmount}</td>
                            </tr>

                            <tr>
                              <th>
                                <h5>Total:</h5>
                              </th>
                              <td>
                                <h5>${totatBillAmount} </h5>(
                                {amountToWords(totatBillAmount)})
                              </td>
                            </tr>

                            <>
                              <tr>
                                <th>
                                  <span className="green">Paid Amount:</span>
                                </th>
                                <td>
                                  <span className="green">
                                    ${bidDetails?.paidAmount}
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <th>
                                  <h5 className="red">Balance Amount:</h5>
                                </th>
                                <td>
                                  <h5 className="red">
                                    ${bidDetails?.pendingAmount}
                                  </h5>
                                  <span className="red">
                                    ({amountToWords(bidDetails?.pendingAmount)})
                                  </span>
                                </td>
                              </tr>
                            </>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="row no-print">
                    <div className="col-12">
                      {/* <a
                        rel="noopener"
                        target="_blank"
                        className="btn btn-default"
                        onClick={handlePrint}
                      >
                        <i className="fas fa-print" /> Print
                      </a> */}

                      {/* <button
                        type="button"
                        className="btn btn-success float-right"
                      >
                        <i className="far fa-credit-card" /> Submit Payment
                      </button> */}
                      <button
                        rel="noopener"
                        target="_blank"
                        className="btn btn-info"
                        onClick={handlePrint}
                      >
                        <i className="fas fa-print" /> Print
                      </button>
                      {/* <button
                        type="button"
                        className="btn btn-primary float-right"
                        style={{ marginRight: "5px" }}
                        onClick={handleSendInvoice}
                      >
                        <i className="fas fa-download" /> Send Invoice
                      </button> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </DashboardLayout>
  );
};

export default BidDetails;

